import { useEffect, useRef } from "react";
import type { IModalProps } from "./types";
import { CloseButton, ModalBox, ModalOverlay } from "./styles";
import XIcon from "../../../assets/icons/XIcon";

export const ModalComponent: React.FC<IModalProps> = ({
  children,
  closeModal,
  label,
}) => {
  const modalRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleOutclick = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node) &&
        closeModal
      ) {
        closeModal();
      }
    };

    window.addEventListener("mousedown", handleOutclick);

    return () => {
      window.removeEventListener("mousedown", handleOutclick);
    };
  }, []);

  useEffect(() => {
    const handleKeydown = (event: any) => {
      if (event.key === "Escape" && closeModal) {
        closeModal();
      }
    };

    window.addEventListener("keydown", handleKeydown);

    return () => {
      window.removeEventListener("keydown", handleKeydown);
    };
  }, []);

  return (
    <ModalOverlay>
      {/*
        ponytail: semântica de diálogo e nome acessível, sem armadilha de foco. O
        teto é esse: leitor de tela anuncia o diálogo e o Esc fecha, mas o Tab
        ainda escapa para o conteúdo atrás. Upgrade, quando alguém pedir, é
        prender o foco no ModalBox e devolvê-lo ao gatilho no fechamento — mexe
        em 21 call sites de comportamento, não só de rótulo.
      */}
      <ModalBox ref={modalRef} role="dialog" aria-modal="true" aria-label={label}>
        {closeModal ? (
          <CloseButton type="button" aria-label="Fechar" onClick={closeModal}>
            <XIcon />
          </CloseButton>
        ) : null}
        {children}
      </ModalBox>
    </ModalOverlay>
  );
};
